/* global _LTracker */ // @flow
import * as React from 'react';
import Validators, { IValidatorPackage } from '../../Validators';
import CheckboxField from '../CheckboxField/CheckboxField';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import Popup from "reactjs-popup";
import { withLocalize, Translate } from "react-localize-redux";

import './Agreement.css';

// import Recaptcha from 'react-recaptcha';
// const Recaptcha = require('react-recaptcha');
// import { ReCaptcha } from 'react-recaptcha-v3';
import Recaptcha from 'react-google-invisible-recaptcha';

interface IAgreementProps {
    checkedTerms: boolean;
    checkedRules: boolean;
    checkedRelease: boolean;
    checkedNewsletter: boolean;
    checkedSmsOptIn: boolean;
    hasChildren: boolean;
    handleClickBack: () => void;
    handleClickNext: () => void;
    updateCheckTerms: (value: boolean) => void;
    updateCheckRules: (value: boolean) => void;
    updateCheckRelease: (value: boolean) => void;
    updateCheckNewsletter: (value: boolean) => void;
    updateCheckCovid: (value: boolean) => void;
    updateCheckSmsOptIn: (value: boolean) => void;
    updateReCaptcha: (response: string) => void;
}

interface IAgreementState {
    deferErrors: boolean;

    captchaCompleted: boolean;
    captchaLoaded: boolean;
}

class Agreement extends React.Component<IAgreementProps, IAgreementState> {
    validators: {
        [key: string]: IValidatorPackage[];
        checkedTerms: IValidatorPackage[];
        checkedRules: IValidatorPackage[];
    };

    constructor(props: IAgreementProps) {
        super(props);

        this.state = {
            deferErrors: true,
            captchaCompleted: false,
            captchaLoaded: false,
            checkedRules: false,
            checkTerms: false,
            checkCovid: false,

            checkSmsOptIn: false,

            tac_open: false,
            rules_open: false,
            mr_open: false,
            finalValidate: false,

            toc_url: "https://www.ctrlv.ca/legal/terms-and-conditions/",
            toc_url_no_header: "https://www.ctrlv.ca//legal/terms-and-conditions?noheaderfooter",
            rules_url: "https://www.ctrlv.ca//legal/usage-rules-ctrl-v/",
            rules_url_no_header: "https://www.ctrlv.ca//legal/ctrl-v-rules?noheaderfooter",
            media_url: "https://www.ctrlv.ca//legal/media-release/",
            media_url_no_header: "https://www.ctrlv.ca/legal/media-release?noheaderfooter"
        };

        this.openTaCModal = this.openTaCModal.bind(this)
        this.closeTaCModal = this.closeTaCModal.bind(this)
        this.openRulesModal = this.openRulesModal.bind(this)
        this.closeRulesModal = this.closeRulesModal.bind(this)
        this.openMRModal = this.openMRModal.bind(this)
        this.closeMRModal = this.closeMRModal.bind(this)
        this.onCaptchaResponse = this.onCaptchaResponse.bind(this);

        this.validators = {
            checkedTerms: [{
                validator: Validators.requiredBool,
                errorMessage: <Translate id="constants_js.required" />
            }],
            checkedRules: [{
                validator: Validators.requiredBool,
                errorMessage: <Translate id="constants_js.required" />
            }]
        };
    }

    componentDidMount() {
        let getUrl = window.location;
		let baseUrl = getUrl.protocol + "//" + getUrl.host;

        this.setState({
            toc_url: `${baseUrl}/legal/terms-and-conditions/`,
            toc_url_no_header: `${baseUrl}/legal/terms-and-conditions?noheaderfooter`,
            rules_url: `${baseUrl}/legal/usage-rules-ctrl-v/`,
            rules_url_no_header: `${baseUrl}/legal/ctrl-v-rules?noheaderfooter`,
            media_url: `${baseUrl}/legal/media-release/`,
            media_url_no_header: `${baseUrl}/legal/media-release?noheaderfooter`
        });
    };

    validate() {
        const validatorKeys = Object.keys(this.validators);
        for (let i = 0; i < validatorKeys.length; i++) {
            const prop = validatorKeys[i];
            const validators = this.validators[prop];
            for (let j = 0; j < validators.length; j++) {
                const validatorPackage = validators[j];
                if (validatorPackage.validator(this.props[prop].toString()) === false) {
                    if (!this.state.deferErrors) {
                        _LTracker.push({
                            validatorPackage, info: {
                                type: `Failed To Validate`,
                                details: this.props[prop],
                                prop: prop
                            }
                        });
                    }
                    return false;
                }
            }
        }
        return true;
    }

    onChangeTerms = (value: boolean) => {
        if(value){
            this.setState({checkedTerms:true })
        }
        this.props.updateCheckTerms(value);
    }

    onChangeRules = (value: boolean) => {
        if(value){
            this.setState({checkedRules:true })
        }
        this.props.updateCheckRules(value);
    }

    onChangeRelease = (value: boolean) => {
        this.props.updateCheckRelease(value);
    }

    onChangeNewsletter = (value: boolean) => {
        this.props.updateCheckNewsletter(value);
    }

    onChangeSmsOptIn = (value: boolean) => {
        this.props.updateCheckSmsOptIn(value);
    }

    onCaptchaExpired = () => {
        console.log('Captcha expired');
        this.expireCaptcha();
    }

    onCaptchaLoaded = () => {
        console.log('Captcha Successfully loaded');
        this.setState({ captchaLoaded: true });
    }

    onCaptchaResponse = () => {
        console.log(this.recaptcha.getResponse());
        this.completeCaptcha(this.recaptcha.getResponse());
    }

    completeCaptcha = (response: string) => {
        console.log("Received captcha response:", !(response === '' || response === undefined));
        this.setState({
            captchaCompleted: !(response === '' || response === undefined),
        });
        this.props.updateReCaptcha(response);
        if (this.state.finalValidate === true)
            this.props.handleClickNext();
    }

    expireCaptcha = () => {
        console.log("Expiring captcha");
        this.setState({ captchaCompleted: false });
    }

    onClickBack = () => {
        console.log("Back clicked. Going to Hear About.");
        this.props.handleClickBack();
    }

    onClickNext = () => {
        if (this.validate()) {
            console.log('Next clicked. Proceeding to send message.');

            this.setState({ finalValidate: true });
            this.recaptcha.execute();
        }
        else {
            console.log('this.validate() failed.');
            this.setState({ deferErrors: false });
        }
    }

    openTaCModal() {
        this.setState({ tac_open: true })
    }
    closeTaCModal() {
        this.setState({ tac_open: false })
    }
    openRulesModal() {
        this.setState({ rules_open: true })
    }
    closeRulesModal() {
        this.setState({ rules_open: false })
    }
    openMRModal() {
        this.setState({ mr_open: true })
    }
    closeMRModal() {
        this.setState({ mr_open: false })
    }

    render() {
        let nextIsEnabled = (this.state.deferErrors === true || this.validate()) && this.props.checkedTerms && this.props.checkedRules;
        console.log(`nextCheck: ${this.state.deferErrors} | ${this.validate()} | ${this.props.checkedRules && this.props.checkedTerms}`);

        return (
            <div className={'Agreement'}>
                <Header
                    header={<Translate id="agreement_js.header" />}
                    subHeader={<Translate id="agreement_js.sub_header" />}
                />
                <div className={'Agreement-preamble'}>
                    {<Translate id="agreement_js.agreement_preamble" />}
                </div>
                <CheckboxField
                    label={
                        <div>
                            <button className={'TaCButton'} onClick={this.openTaCModal}> {this.state.toc_url} <span className={'CheckboxField-required'}>{' *'}</span></button>
                            <Translate>
                                {({ translate }) =>
                                    <Popup
                                        open={this.state.tac_open}
                                        onClose={this.closeTaCModal}
                                        closeOnDocumentClick
                                    >
                                        <div className="modal">
                                            <button className="close" onClick={this.closeTaCModal}>
                                                &times;
                                </button>
                                            <div className="modalWrapper">
                                                <iframe
                                                    className="termsModals"
                                                    title="termsandcondiitons"
                                                    sandbox="allow-scripts allow-same-origin"
                                                    scrolling="yes"
                                                    src={this.state.toc_url_no_header}
                                                />
                                            </div>
                                        </div>
                                    </Popup>
                                }
                            </Translate>
                        </div>
                    }
                    isLabelLink={false}
                    checkLabel={<Translate id="agreement_js.label_check_toc" />}
                    checked={this.props.checkedTerms}
                    handleChange={this.onChangeTerms}
                    required={true}
                    validators={this.validators.checkedTerms}
                    deferErrors={this.state.deferErrors}
                />
                <CheckboxField
                    label={
                        <div>
                            <button className={'TaCButton'} onClick={this.openRulesModal}> {this.state.rules_url} <span className={'CheckboxField-required'}>{' *'}</span></button>
                            <Translate>
                                {({ translate }) =>
                                    <Popup
                                        open={this.state.rules_open}
                                        onClose={this.closeRulesModal}
                                        closeOnDocumentClick
                                    >
                                        <div className="modal">
                                            <button className="close" onClick={this.closeRulesModal}>
                                                &times;
                                </button>
                                            <div className="modalWrapper">
                                                <iframe
                                                    className="termsModals"
                                                    title="ctrlvrules"
                                                    sandbox="allow-scripts allow-same-origin"
                                                    scrolling="yes"
                                                    src={this.state.rules_url_no_header}
                                                />
                                            </div>
                                        </div>
                                    </Popup>
                                }
                            </Translate>
                        </div>
                    }
                    isLabelLink={false}
                    checkLabel={<Translate id="agreement_js.label_check_rules" />}
                    checked={this.props.checkedRules}
                    handleChange={this.onChangeRules}
                    required={true}
                    validators={this.validators.checkedRules}
                    deferErrors={this.state.deferErrors}
                />
                <Translate>
                    {({ translate }) =>
                        <CheckboxField
                            label={
                                <div>
                                    <button className={'TaCButton'} onClick={this.openMRModal}>{this.state.media_url}</button>
                                    <Popup
                                        open={this.state.mr_open}
                                        onClose={this.closeMRModal}
                                        closeOnDocumentClick
                                    >
                                        <div className="modal">
                                            <button className="close" onClick={this.closeMRModal}>
                                                &times;
                                </button>
                                            <div className="modalWrapper">
                                                <iframe
                                                    className="termsModals"
                                                    title="mediarelease"
                                                    sandbox="allow-scripts allow-same-origin"
                                                    scrolling="yes"
                                                    src={this.state.media_url_no_header}
                                                />
                                            </div>
                                        </div>
                                    </Popup>
                                </div>
                            }
                            isLabelLink={false}
                            checkLabel={translate("agreement_js.label_media_pre") + (this.props.hasChildren ? translate("agreement_js.label_media_with_children") : ``) + translate("agreement_js.label_media_post")}
                            checked={this.props.checkedRelease}
                            handleChange={this.onChangeRelease}
                            validators={[]}
                            deferErrors={this.state.deferErrors}
                        />
                    }
                </Translate>

                <CheckboxField
                    label={<Translate id="agreement_js.label_newsletter" />}
                    checkLabel={<Translate id="agreement_js.label_newsletter_check" />}
                    checked={this.props.checkedNewsletter}
                    handleChange={this.onChangeNewsletter}
                    validators={[]}
                    deferErrors={this.state.deferErrors}
                />

                <CheckboxField
                    label={<Translate id="agreement_js.label_sms_opt_in" />}
                    checkLabel={<Translate id="agreement_js.label_sms_opt_in_check" />}
                    checked={this.props.checkedSmsOptIn}
                    handleChange={this.onChangeSmsOptIn}
                    validators={[]}
                    deferErrors={this.state.deferErrors}
                />


                {/* Try new recaptcha system */}
                <Recaptcha
                    ref={ref => this.recaptcha = ref}
                    sitekey="6LfpdX0UAAAAAHy2VAjDtsJi9Ba6LW_ao4OXlWe9"
                    onResolved={this.onCaptchaResponse} />
                <Footer
                    nextEnabled={nextIsEnabled}
                    handleClickBack={this.onClickBack}
                    handleClickNext={this.onClickNext}
                    nextText={<Translate id="footer_js.next" />}
                    backText={<Translate id="footer_js.back" />}
                />
            </div>
        );
    }
}

export default withLocalize(Agreement);
// export default Agreement;
